document.addEventListener("DOMContentLoaded", function () {
    initAddArrowSpan();
});

function initAddArrowSpan() {
    const buttons = document.querySelectorAll('.is-style-wp-jumplinks-default .wp-block-button__link');
    if (!buttons.length) return;
    buttons.forEach(btn => {
        // prevent duplicate arrow span
        if (btn.querySelector('.btn-arrow')) return;
        const arrowSpan = document.createElement('span');
        arrowSpan.className = 'btn-arrow';
        btn.appendChild(arrowSpan);
    });
}





